import { render, staticRenderFns } from "./TalkArea.vue?vue&type=template&id=0721cfea&scoped=true&"
import script from "./TalkArea.vue?vue&type=script&lang=ts&"
export * from "./TalkArea.vue?vue&type=script&lang=ts&"
import style0 from "./TalkArea.vue?vue&type=style&index=0&id=0721cfea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0721cfea",
  null
  
)

export default component.exports